import Navbar from "./Navbar";
// import Signature from "./Signature";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <>
      <Outlet />
      <Navbar />
      {/* <Signature /> */}
    </>
  );
}